import { Component, OnInit } from '@angular/core';
import { ChartType, ChartOptions, ChartDataset } from 'chart.js';

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.css']
})
export class PieChartComponent implements OnInit {
  public pieChartOptions: ChartOptions<'pie'> = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
    }
  };
  public pieChartLabels: string[] = ['Pending Jobs', 'Approved Jobs', 'Jobs in Production'];
  public pieChartDatasets: ChartDataset<'pie'>[] = [{
    data: [300, 500, 100],
    backgroundColor: [
      'rgba(239, 68, 68, 0.3)',
      'rgba(34, 197, 94, 0.3)',
      'rgba(59, 130, 246, 0.3)',
    ],
  }];
  public pieChartType: 'pie' = 'pie';
  public pieChartLegend = true;

  constructor() { }

  ngOnInit(): void {
  }

  // events
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

  changeLabels(): void {
    const words = ['hen', 'variable', 'embryo', 'instal', 'pleasant', 'physical', 'bomber', 'army', 'add', 'film',
      'conductor', 'comfortable', 'flourish', 'establish', 'circumstance', 'chimney', 'crack', 'hall', 'energy',
      'treat', 'window', 'shareholder', 'division', 'disk', 'temptation', 'chord', 'left', 'hospital', 'beef',
      'patrol', 'satisfied', 'academy', 'acceptance', 'ivory', 'aquarium', 'building', 'store', 'replace', 'language',
      'redeem', 'honest', 'intention', 'silk', 'opera', 'sleep', 'innocent', 'ignore', 'suite', 'applaud', 'funny'];
    const randomWord = () => words[Math.trunc(Math.random() * words.length)];
    this.pieChartLabels = Array.apply(null, [{ length: 3 }]).map(_ => randomWord());
  }

  addSlice(): void {
    this.pieChartLabels.push('New Slice');
    this.pieChartDatasets[0].data.push(400);
    (this.pieChartDatasets[0].backgroundColor as string[]).push('rgba(168, 85, 247, 0.3)');
  }

  removeSlice(): void {
    this.pieChartLabels.pop();
    this.pieChartDatasets[0].data.pop();
    (this.pieChartDatasets[0].backgroundColor as string[]).pop();
  }

  changeLegendPosition(): void {
   // this.pieChartOptions.legend.position = this.pieChartOptions.legend.position === 'left' ? 'top' : 'left';
  }
}
